<select id="#select" (change)="onChange($event)"
        data-te-select-init
        data-te-select-placeholder=" "
        [formControl]="control">
    @for (option of options; track option) {
        <option [value]="option.value">{{ option.label }}</option>
    }
</select>
<label for="#select" data-te-select-label-ref>{{ placeholder }}</label>